import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M31.683 10.667H.34c.131-.925.305-1.86.526-2.792 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.22.916.39 1.84.516 2.758",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.34 10.667h31.343c.254 1.844.336 3.663.314 5.35a35 35 0 0 1-.337 5.316H.325a35 35 0 0 1-.322-5.35c-.022-1.66.074-3.469.337-5.316",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.325 21.333H31.66a31 31 0 0 1-.527 2.791s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.232-.93-.41-1.865-.54-2.79",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "m12.163 11.676.42-6.35a11.82 11.82 0 0 0-10.35 0l.42 6.35c.189 2.854 2.082 5.29 4.755 6.116 2.672-.827 4.566-3.263 4.754-6.116"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M3.026 11.65c.175 2.653 1.911 4.927 4.382 5.741 2.47-.814 4.206-3.088 4.382-5.74l.43-6.494C12.275 5.184 10.05 4 7.408 4 4.79 4 2.53 5.189 2.596 5.157z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      d: "M3.526 12.537c.45 2.074 1.92 3.76 3.881 4.451 1.962-.691 3.432-2.377 3.882-4.451l-1.941-2.65-.776 1.06L7.407 8.56l-1.164 2.385-.776-1.06z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M3.7 13.2a1.3 1.3 0 0 0 .786.617c.331.09.684.043.981-.133.4-.236.894-.236 1.294 0 .4.237.894.237 1.294 0 .4-.236.893-.236 1.294 0 .297.176.65.224.981.133.332-.091.614-.313.786-.618v.383a1.3 1.3 0 0 1-.786.617 1.26 1.26 0 0 1-.981-.132 1.27 1.27 0 0 0-1.294 0c-.4.237-.894.237-1.294 0a1.27 1.27 0 0 0-1.294 0c-.297.176-.65.223-.981.132a1.3 1.3 0 0 1-.786-.617z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      d: "M3.7 13.964c.172.305.454.527.786.618.331.09.684.043.981-.133.4-.236.894-.236 1.294 0 .4.237.894.237 1.294 0 .4-.236.893-.236 1.294 0 .297.176.65.224.981.133.332-.091.614-.313.786-.618v.383a1.3 1.3 0 0 1-.786.617 1.27 1.27 0 0 1-.981-.132 1.27 1.27 0 0 0-1.294 0c-.4.237-.894.237-1.294 0a1.27 1.27 0 0 0-1.294 0c-.297.176-.65.223-.981.132a1.3 1.3 0 0 1-.786-.617z"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      d: "m7.408 6.739.097.324.323-.076-.226.249.226.248-.323-.076-.097.325-.097-.325-.323.076.226-.248-.226-.249.323.076zM5.952 4.75l.097.326.323-.077-.226.249.226.248-.323-.076-.097.325-.097-.325-.323.076.226-.248-.226-.249.323.077zm2.911 0 .097.326.323-.077-.226.249.226.248-.323-.076-.097.325-.097-.325-.323.076.226-.248-.226-.249.323.077z"
    }
  )
);
var SvgFlagSvn = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagSvn_default = SvgFlagSvn;

export { FlagSvn_default as default };
